import {createAction} from '@reduxjs/toolkit'
import {EndpointsConfigTypes, UpdateEndpointsConfigAction} from 'interfaces'

const getEndpointsConfig = createAction('getEndpointsConfig')
const getEndpointsConfigFailure = createAction<string>(
  'getEndpointsConfigFailure',
)
const getEndpointsConfigSuccess = createAction<EndpointsConfigTypes>(
  'getEndpointsConfigSuccess',
)

const updateEndpointsConfig = createAction<UpdateEndpointsConfigAction>(
  'updateEndpointsConfig',
)
const updateEndpointsConfigFailure = createAction<string>(
  'updateEndpointsConfigFailure',
)
const updateEndpointsConfigSuccess = createAction<string>(
  'updateEndpointsConfigSuccess',
)
const setEndpointConfigFormValidation = createAction<boolean>(
  'setEndpointConfigFormValidation',
)
const setShowEndpointConfigView = createAction<boolean>(
  'setShowEndpointConfigView',
)

export {
  getEndpointsConfig,
  getEndpointsConfigFailure,
  getEndpointsConfigSuccess,
  updateEndpointsConfig,
  updateEndpointsConfigFailure,
  updateEndpointsConfigSuccess,
  setEndpointConfigFormValidation,
  setShowEndpointConfigView,
}
